import collections from "./collections"
import categories from "./categories"

export default {
  collections,
  categories,
}
